/**
 * QuoteForm: edit form for the `quote` block.
 *
 * data: { text, attribution?, attributionUrl? }
 *
 * A textarea for the quote body and text inputs for the optional
 * attribution and its link.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

export default function QuoteForm({ data, onChange }) {
    const d = data || {};

    const update = (field, value) => {
        onChange({ ...d, [field]: value });
    };

    return (
        <>
            <Form.Group className="mb-3" controlId="quote-text">
                <Form.Label>Quote</Form.Label>
                <Form.Control
                    as="textarea"
                    rows={3}
                    value={d.text || ''}
                    onChange={(e) => update('text', e.target.value)}
                    placeholder="The quoted text"
                />
            </Form.Group>
            <Form.Group className="mb-3" controlId="quote-attribution">
                <Form.Label>Attribution</Form.Label>
                <Form.Control
                    type="text"
                    value={d.attribution || ''}
                    onChange={(e) => update('attribution', e.target.value)}
                    placeholder="Who said it (optional)"
                />
            </Form.Group>
            <Form.Group className="mb-3" controlId="quote-attributionUrl">
                <Form.Label>Attribution Link (optional)</Form.Label>
                <Form.Control
                    type="text"
                    value={d.attributionUrl || ''}
                    onChange={(e) => update('attributionUrl', e.target.value)}
                    placeholder="/about or https://..."
                />
            </Form.Group>
        </>
    );
}

QuoteForm.propTypes = {
    data: PropTypes.object,
    onChange: PropTypes.func.isRequired,
};

QuoteForm.defaultProps = {
    data: {},
};
